import React from 'react';
import { Rate, Form } from 'antd';

const FormCustomRating = ({
  label,
  name,
  rules,
  value,
  onChange,
  customIcons,
  disabled,
  ...rest
}) => {
  return (
    <Form.Item label={label} name={name} rules={rules}>
      <Rate
        value={value}
        onChange={onChange}
        disabled={disabled}
        character={
          customIcons ? ({ index }) => customIcons[index + 1] : undefined
        }
        {...rest}
      />
    </Form.Item>
  );
};

export default FormCustomRating;
